// PDP Upsell Events
function checkShopLookVisibility() {
  function isFullyInViewport(el) {
    const rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= viewportHeight &&
      rect.right <= viewportWidth
    );
  }

  const shopItems = Array.from(document.querySelectorAll('.shop-look__item'));
  for (const el of shopItems) {
    if (el.dataset.seen === 'true') continue;
    if (isFullyInViewport(el)) {
      el.dataset.seen = 'true';
      dataLayer.push({
        event: 'custom_event',
        event_name: 'product_page_element_view',
        parameter: JSON.stringify({
          type: 'shop_my_look_details',
          item_name: el.dataset.stlProductUrl,
          content_number: `${el.dataset.swiperSlideIndex ? Number(el.dataset.swiperSlideIndex) + 1 : shopItems.indexOf(el) + 1}`
        })
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('scroll', checkShopLookVisibility);
  checkShopLookVisibility();
});

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll(
    '.one_category-products-list .product-item'
  );
  const seenItems = new WeakSet();

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        const item = entry.target;

        if (seenItems.has(item)) return;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.95) {
          let slider;
          if (item.closest('.slick-slider')) {
            slider = item.closest('.slick-slider');
          } else if (item.closest('.slider_4')) {
            slider = item.closest('.slider_4');
          } else if (item.closest('.slider_44')) {
            slider = item.closest('.slider_44');
          } else {
            return;
          }
          const siblings = Array.from(
            slider.querySelectorAll('.product-item:not(.slick-cloned)')
          );
          const index = siblings.indexOf(item) + 1;
          let type = item.dataset.collection;
          let href = item
            .querySelector('a.card-information__wrapper-link')
            .getAttribute('href');
          if (!href) {
            const linkEl = item.querySelector(
              'a.card-information__wrapper-link'
            );
            href = linkEl?.dataset.stlProductUrl;
          }
          if (document.body.dataset.template === 'cart') {
            type = 'cart_page';
          }
          if (!href) return;

          dataLayer.push({
            event: 'custom_event',
            event_name: 'product_page_element_view',
            parameter: JSON.stringify({
              type: type,
              item_name: href.split('/').pop(),
              content_number: `${index}`
            })
          });

          seenItems.add(item);
          obs.unobserve(item);
        }
      });
    },
    {
      root: null,
      threshold: 0.95
    }
  );

  items.forEach(item => observer.observe(item));
});

document.addEventListener(
  'pointerdown',
  event => {
    const modal = document.querySelector('.quick-buy-modal.active');
    if (!modal) return;

    if (event.target.closest('.quick-buy-modal__close')) {
      dataLayer.push({
        event: 'custom_event',
        event_name: 'product_popup_close_click',
        parameter: JSON.stringify({
          from: modal.dataset.collection,
          type: 'close_button'
        })
      });
      return;
    }

    if (!modal.contains(event.target)) {
      dataLayer.push({
        event: 'custom_event',
        event_name: 'product_popup_close_click',
        parameter: JSON.stringify({
          from: modal.dataset.collection,
          type: 'area'
        })
      });
      return;
    }
  },
  true
);

document.addEventListener('click', event => {
  const detailsBtn = event.target.closest(
    '.shop-look__modal.active a.btn-details'
  );
  if (detailsBtn) {
    const href = detailsBtn.getAttribute('href');
    dataLayer.push({
      event: 'custom_event',
      event_name: 'product_popup_product_details_click',
      parameter: JSON.stringify({
        item_name: href.split('/').pop()
      })
    });
  }
});

let previousOnePagerColor = null;

document.addEventListener('DOMContentLoaded', () => {
  if (document.body.dataset.template?.includes('one_pager')) {
    const initialOnePagerInput = document.querySelector(
      '.product_variants .product-form__input input:checked'
    );
    if (initialOnePagerInput) {
      previousOnePagerColor = initialOnePagerInput.value;
    }
  } else if (document.body.dataset.template?.includes('supplements-bundles')) {
    const initialOnePagerInput = document.querySelector(
      '.product_variants .product-color_label .color_value'
    );
    if (initialOnePagerInput) {
      previousOnePagerColor = initialOnePagerInput.textContent;
    }
  }
});

document.addEventListener('click', event => {
  const isOnePager = document.body.dataset.template?.includes('one_pager');
  const isSupBundles = document.body.dataset.template?.includes(
    'supplements-bundles'
  );

  let targetColor = null;

  if (isOnePager) {
    targetColor = event.target.closest(
      '.product_variants .product-form__input.color_option_input input'
    );
  } else if (isSupBundles) {
    targetColor = event.target.closest(
      '.product_variants .color-palette .prod-variant'
    );
  } else {
    targetColor = event.target.closest(
      '.product__info-wrapper .product-alt-colours a.color_swatch_item'
    );
  }

  if (!targetColor) return;

  const productHandle = document.querySelector(
    '.product-default[data-handle], section.product-default'
  )?.dataset.handle;

  let fromValue;
  let toValue;

  if (isOnePager) {
    fromValue = previousOnePagerColor ?? targetColor.value;
    toValue = targetColor.value;
    previousOnePagerColor = toValue;
  } else if (isSupBundles) {
    fromValue = previousOnePagerColor ?? targetColor.dataset.colorName;
    toValue = targetColor.dataset.colorName;
    previousOnePagerColor = toValue;
  } else {
    const activeColorSpan = document.querySelector(
      '.product__info-wrapper div.color_swatch_item-span.color_active'
    );

    fromValue = document.body.dataset.template?.includes('supplement-new')
      ? activeColorSpan.dataset.colorName
      : activeColorSpan.parentElement.dataset.colorName;
    toValue = targetColor.dataset.colorName;
  }

  const pdpExtras = readPdpEventExtras();
  dataLayer.push({
    event: 'custom_event',
    event_name: 'product_color_change',
    parameter: JSON.stringify({
      from: fromValue,
      value: toValue,
      content_url: productHandle,
      type: 'product',
      item_id: pdpExtras.item_id,
      product_collection: pdpExtras.product_collection
    })
  });
});

document.addEventListener(
  'click',
  event => {
    const swatchEl = event.target.closest(
      '.product-item .color_swatch_item-span'
    );
    if (!swatchEl) return;
    const itemEl = swatchEl.closest('.product-item');

    const activeEl = itemEl.querySelector(
      '.color_swatch_item-span.color_active'
    );

    const prevData = JSON.parse(activeEl.closest('a').dataset.quickAddProdInfo);
    const nextData = JSON.parse(swatchEl.closest('a').dataset.quickAddProdInfo);

    dataLayer.push({
      event: 'custom_event',
      event_name: 'product_color_change',
      parameter: JSON.stringify({
        from: prevData.color,
        value: nextData.color,
        content_url: nextData.url.split('/').pop(),
        type: itemEl.dataset.collection,
        ...buildProductExtras({
          variant: nextData.variants?.[0]?.id,
          collection: nextData.main_collections
        })
      })
    });
  },
  true
);

document.addEventListener('click', event => {
  const viewAllBtn = event.target.closest(
    '.one_category-products-list .main_heading a.btn_white'
  );
  if (viewAllBtn) {
    const section = viewAllBtn.closest('.one_category-products-list');
    const itemEl = section.querySelector('.item');
    dataLayer.push({
      event: 'custom_event',
      event_name: 'product_page_upsells_view_all_click',
      parameter: JSON.stringify({
        from: itemEl.dataset.collection
      })
    });
  }
});

let previousSize = null;

document.addEventListener(
  'pointerdown',
  event => {
    const sizeBtn = event.target.closest(
      'variant-radios .size_option_input .size_slider .item'
    );
    if (!sizeBtn) return;
    const activeSize = document.querySelector(
      'variant-radios .size_option_input .size_slider .item input:checked'
    );

    previousSize = activeSize ? activeSize.value : null;
  },
  true
);

document
  .querySelectorAll(
    'variant-radios .size_option_input .size_slider .item input'
  )
  .forEach(input => {
    input.addEventListener('change', function () {
      const newValue = this.value;
      if (previousSize && newValue && newValue !== previousSize) {
        const _sizeExtras = readPdpEventExtras();
        dataLayer.push({
          event: 'custom_event',
          event_name: 'product_size_change',
          parameter: JSON.stringify({
            from: previousSize,
            value: newValue,
            content_url: this.closest(
              '.product-default[data-handle], section.product-default'
            )?.dataset.handle,
            type: 'product',
            ..._sizeExtras
          })
        });
      }
    });
  });

document
  .querySelectorAll('.product_variants .flavor-palette .prod-variant')
  .forEach(variant => {
    variant.addEventListener('click', function () {
      const previous = document.querySelector(
        '.product_variants .flavor-palette .prod-variant.active'
      )?.dataset.flavorName;

      const next = this.dataset.flavorName;

      const _flavorExtras = readPdpEventExtras();
      dataLayer.push({
        event: 'custom_event',
        event_name: 'product_size_change',
        parameter: JSON.stringify({
          from: previous,
          value: next,
          content_url: this.closest(
            '.product-default[data-handle], section.product-default'
          )?.dataset.handle,
          type: 'product',
          ..._flavorExtras
        })
      });
    });
  });
document.addEventListener(
  'click',
  event => {
    const viewAllBtn = event.target.closest(
      '.capsule-landing-categories .capsule-landing-categories__bar a'
    );
    if (!viewAllBtn) return;

    const category = viewAllBtn.closest('.capsule-category');
    dataLayer.push({
      event: 'custom_event',
      event_name: 'product_page_upsells_view_all_click',
      parameter: JSON.stringify({
        from: category.dataset.collection
      })
    });
  },
  true
);

document.addEventListener('DOMContentLoaded', () => {
  if (
    document.body.dataset.template === 'product.pil-ess-kit-lp-store' ||
    document.body.dataset.template === 'product.lp-pilatess-essential-kit'
  ) {
    const sections = document.querySelectorAll('[section-event-name]');
    const seenSections = new WeakSet();

    const sectionObserver = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach(entry => {
          const section = entry.target;
          if (seenSections.has(section)) return;

          if (entry.isIntersecting && entry.intersectionRatio >= 0.8) {
            seenSections.add(section);
            obs.unobserve(section);

            dataLayer.push({
              event: 'custom_event',
              event_name: 'product_page_element_view',
              parameter: JSON.stringify({
                section_name: section.getAttribute('section-event-name')
              })
            });
          }
        });
      },
      {
        root: null,
        threshold: 0.8
      }
    );

    sections.forEach(section => sectionObserver.observe(section));
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll(
    '.capsule-landing-categories .product-item'
  );
  const seenItems = new WeakSet();

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        const item = entry.target;

        if (seenItems.has(item)) return;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.95) {
          let slider;
          slider = item.closest('.capsule-slider__track');

          if (!slider) {
            return;
          }

          const siblings = Array.from(slider.querySelectorAll('.product-item'));
          const index = siblings.indexOf(item) + 1;
          let type = item.dataset.collection;
          let href = item
            .querySelector('a.card-information__wrapper-link')
            .getAttribute('href');

          if (!href) return;

          dataLayer.push({
            event: 'custom_event',
            event_name: 'product_page_element_view',
            parameter: JSON.stringify({
              type: type,
              item_name: href.split('/').pop(),
              content_number: `${index}`
            })
          });

          seenItems.add(item);
          obs.unobserve(item);
        }
      });
    },
    {
      root: null,
      threshold: 0.95
    }
  );

  items.forEach(item => observer.observe(item));
});
